/* ==========================================================================
   Vildblad 2.3 — färgval i produktkort och svenska namn på varianter
   ========================================================================== */
(() => {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---------- Färgprickar i produktkort: byt bild, länk, pris och snabbköp ---------- */
  const selectSwatch = (sw) => {
    const card = sw.closest('[data-product-card]');
    if (!card) return;
    $$('[data-card-swatch]', card).forEach((b) => b.setAttribute('aria-pressed', b === sw ? 'true' : 'false'));

    const url = sw.dataset.url;
    if (url) {
      card.dataset.productUrl = url;
      $$('.card__media > a[href], .card__title a[href]', card).forEach((a) => { a.href = url; });
    }

    const img = $('.card__img-primary', card);
    if (img && sw.dataset.img) {
      if (sw.dataset.srcset) img.srcset = sw.dataset.srcset;
      img.src = sw.dataset.img;
      if (sw.dataset.alt) img.alt = sw.dataset.alt;
      img.loading = 'eager';
      card.classList.add('card--swatched');
    }

    if (card.hasAttribute('data-price-varies') && sw.dataset.price) {
      const price = $('[data-card-price]', card);
      if (price) price.textContent = sw.dataset.price;
    }

    // Plus för en färg som finns, ringklocka (Bevaka) för en färg som är slut
    const available = sw.dataset.available === 'true';
    const quick = $('[data-card-quick-add]', card);
    if (quick) {
      quick.dataset.quickAdd = sw.dataset.variantId;
      quick.hidden = !available;
      quick.disabled = false;
      if (quick.dataset.labelBase) quick.setAttribute('aria-label', `${quick.dataset.labelBase}, ${sw.title}`);
    }
    const bell = $('[data-notify-open]', card);
    if (bell) {
      bell.dataset.variantId = sw.dataset.variantId;
      bell.dataset.variantLabel = sw.title;
      const base = (bell.getAttribute('aria-label') || '').split(',')[0];
      bell.setAttribute('aria-label', `${base}, ${sw.title}`);
      if (quick) bell.hidden = available;
    }
  };

  document.addEventListener('click', (e) => {
    const sw = e.target.closest('[data-card-swatch]');
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    selectSwatch(sw);
  });

  // Förladda bilden när man håller över eller fokuserar en prick, så bytet går snabbt
  const warm = (e) => {
    const sw = e.target.closest && e.target.closest('[data-card-swatch]');
    if (!sw || sw.dataset.warm || !sw.dataset.img) return;
    sw.dataset.warm = '1';
    const i = new Image();
    if (sw.dataset.srcset) { i.sizes = '(min-width: 750px) 33vw, 50vw'; i.srcset = sw.dataset.srcset; }
    i.src = sw.dataset.img;
  };
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('focusin', warm);

  /* ---------- Produktsidan: svenska namn i rubriken och i fasta köpraden ---------- */
  document.addEventListener('variant:change', (e) => {
    const section = e.target;
    if (!section || !section.querySelector) return;
    const picker = $('[data-variant-picker]', section);
    if (!picker) return;
    // theme.js skriver leverantörens namn först – ersätt direkt efteråt
    setTimeout(() => {
      const labels = $$('fieldset', picker).map((fs) => {
        const input = $('input:checked', fs);
        return input ? (input.dataset.label || input.value) : '';
      });
      $$('[data-option-value]', section).forEach((el, i) => { if (labels[i]) el.textContent = labels[i]; });
      const sticky = $('[data-sticky-variant]', section);
      const variant = e.detail && e.detail.variant;
      if (sticky && variant) {
        const priceEl = $('[data-sticky-price]', sticky);
        const price = priceEl ? priceEl.outerHTML : '';
        sticky.innerHTML = '';
        sticky.append(document.createTextNode(`${labels.filter(Boolean).join(' / ')} · `));
        if (price) sticky.insertAdjacentHTML('beforeend', price);
      }
    }, 0);
  });
})();

/* ==========================================================================
   Vildblad 2.4 — sökrutan i sidhuvudet
   theme.js öppnar söklådan. Här flyttas fokus till sökfältet direkt i klicket,
   så att tangentbordet öppnas på mobilen (iOS öppnar det bara i samma tryck).
   ========================================================================== */
(() => {
  'use strict';
  document.addEventListener('click', (e) => {
    const box = e.target.closest('[data-header-search]');
    if (!box) return;
    const input = document.getElementById('SearchDrawerInput');
    if (input) input.focus({ preventScroll: true });
  });
})();

/* ==========================================================================
   Vildblad 2.4 — Bevaka från produktkort (ringklockan)
   theme.js öppnar rutan (data-drawer-open). Här fylls produkt, färg, bild och taggar i.
   Har kunden redan bevakat en annan produkt i samma besök visas ett nytt, tomt formulär.
   ========================================================================== */
(() => {
  'use strict';
  const sheet = document.getElementById('NotifyDrawer');
  if (!sheet) return;
  const $ = (sel, ctx = sheet) => ctx.querySelector(sel);
  const currentForm = () => $('form');
  const first = currentForm();
  const pristine = first && !first.querySelector('.form-status--success') ? first.outerHTML : null;

  const fill = (btn) => {
    const kind = btn.dataset.kind === 'soon' ? 'soon' : 'restock';
    const handle = btn.dataset.handle || '';
    const vid = btn.dataset.variantId || '';
    const key = `${kind}:${handle}:${vid}`;
    const form = currentForm();
    if (form && pristine && form.querySelector('.form-status--success') && sheet.dataset.key !== key) {
      form.outerHTML = pristine;
    }
    sheet.dataset.key = key;
    sheet.dataset.kind = kind;

    $('[data-notify-title]').textContent = btn.dataset.title || '';
    const variant = $('[data-notify-variant]');
    variant.textContent = btn.dataset.variantLabel || '';
    variant.hidden = !btn.dataset.variantLabel;

    const img = $('[data-notify-img]');
    const cardImg = btn.closest('[data-product-card]')?.querySelector('.card__img-primary');
    if (img && cardImg) {
      img.src = cardImg.currentSrc || cardImg.src;
      img.hidden = false;
    } else if (img) {
      img.hidden = true;
    }

    const tags = $('[data-notify-tags]');
    if (tags) {
      const prefix = kind === 'soon' ? 'meddela-mig' : 'bevaka';
      tags.value = [prefix, `${prefix}-${handle}`].concat(vid ? [`${prefix}-${handle}-${vid}`] : []).join(', ');
    }
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-notify-open]');
    if (btn) fill(btn);
  });
})();
